import { FEATURED_IN_COUNTRY } from 'helpers/graphql/locations';
import { useQuery } from '@apollo/client';
import DestinationItem from './DestinationItem';
import Carousel from '../General/Carousel';

export default function SubdivisionSlider({ countryCode }) {
  const { data } = useQuery(FEATURED_IN_COUNTRY, {
    variables: { countryCode },
  });

  if (!data) return <></>;
  return (
    <div className="tw-col-span-3 mt-1 md:mt-0 pl-1 sm:pl-0">
      <Carousel items={data.featuredInCountry}>
        {data.featuredInCountry.map(location => (
          <div
            key={location.subdivision}
            className="tw-shrink-0 tw-w-80 sm:tw-w-96 tw-snap-x tw-snap-mandatory"
          >
            <DestinationItem
              destination={{ ...location, countryCode }}
              isPrio={false}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}
